import {
  type CredentialProvisionResponseStatus,
  GetWorkerCredentialProvisionRequestQuerySchema,
  GetWorkerCredentialProvisionRequestResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";

import { useGetParsedQuery } from "../../api/useGetParsedQuery";
import { environmentConfig } from "../../environment";
import { APP_V2_APP_EVENTS } from "../../lib/analytics";
import { useChartingCredentialProvisioningConfig } from "./useCredentialProvisioningConfig";

interface GetWorkerCredentialProvisionRequestsParams {
  workplaceId: string;
  workerId: string;
  status?: CredentialProvisionResponseStatus;
}

export function buildGetWorkerCredentialProvisionRequestsUrl(
  workplaceId: string,
  workerId: string
): string {
  return `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/workers/${workerId}/worker-credential-provision-requests`;
}

export function useGetWorkerCredentialProvisionRequests(
  params: GetWorkerCredentialProvisionRequestsParams
) {
  const { workplaceId, workerId, status } = params;

  const { enabled: isChartingCredentialProvisioningEnabled } =
    useChartingCredentialProvisioningConfig();

  return useGetParsedQuery({
    url: buildGetWorkerCredentialProvisionRequestsUrl(workplaceId, workerId),
    queryParams: isDefined(status) ? { status } : {},
    queryParamsSchema: GetWorkerCredentialProvisionRequestQuerySchema,
    responseSchema: GetWorkerCredentialProvisionRequestResponseSchema,
    enabled: isChartingCredentialProvisioningEnabled,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_WORKER_CREDENTIAL_PROVISION_REQUEST_FAILURE,
    },
  });
}
